<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">
    Sviluppa la tua prima app. Senza scrivere codice.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    E’ un semplice ambiente di sviluppo per
    <span class="underline-p">applicazioni Android</span>, creato da Google.
    Questo ambiente consente di imparare a creare semplici applicazioni per
    <span class="underline-a">smartphone e tablet</span> utilizzando
    un’interfaccia semplice ed intuitiva.
  </p>
  <div class="d-flex justify-content-center align items center android">
    <img
      src="../../../../assets/img/android.png"
      alt="android"
     
    />
  </div>
</div>

<div class="third container grid">
  <h3 class="w-700 blue-50 text-center">Un ambiente di sviluppo per tutti.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Inizialmente ideato per chi volesse programmare semplici applicazioni per
    Android ad uso personale che possono essere pubblicate sullo store di
    Google. E’ possibile inoltre installare le applicazioni inviandole
    direttamente sul cellulare o tablet tramite usb o via WiFi, provarle su un
    emulatore Android per PC, oppure utilizzare la versione online di
    AppInventor.
  </p>
</div>

<div class="fourth container grid">
  <div class="row">
    <div class="col-xl">
      <img
        src="../../../../assets/img/app-inventor-rect-1.png"
        alt="app inventor"
       
        class="rect-1"
      />
    </div>
    <div class="col-xl"></div>
  </div>
  <div class="row">
    <div class="col-xl"></div>
    <div class="col-xl">
      <img
        src="../../../../assets/img/app-inventor-rect-2.png"
        alt="app inventor"
       
        class="rect-2"
      />
    </div>
  </div>
</div>

<div class="fifth container grid">
  <div class="title">
    <h3 class="w-700 blue-50 text-center">
      Un approccio digitale alle esigenze della vita reale.
    </h3>
  </div>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    La grafica dell’interfaccia è molto semplice ed intuitiva, grazie al
    drag-and-drop dove i blocchi di colore e forme diverse si compongono come un
    puzzle. Il corso consente di realizzare app ludiche o di utilità quotidiana,
    stimolando un approccio digitale alle esigenze della vita reale.
  </p>
</div>

<div class="sixth container grid">
  <div class="row text-center">
    <div class="col-xl">
      <img
        src="../../../../assets/img/app-inventor-rect-3.png"
        alt="app inventor"
       
        class="rect-3"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
